// react
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoBack } from 'hooks/useGoBack';

// components
import {
  NotificationsPage,
  NotificationItem,
} from '@karehero/llama/pwa/pages/NotificationsPage/NotificationsPage';

// store
import {
  useGetNotificationsQuery,
  useUpdateNotificationMutation,
} from 'store/api/notification';

/**
 * Notifications is the notification list view.
 */
export const Notifications = () => {
  // hooks
  const navigate = useNavigate();
  const goBack = useGoBack();
  const [updateNotification] = useUpdateNotificationMutation();

  const { data, isLoading } = useGetNotificationsQuery();

  // methods
  const handleNotificationClick = useCallback(
    async (notification: NotificationItem) => {
      if (!notification.readAt) {
        updateNotification({ id: notification.id, status: 'read' });
      }
      if (notification.deepLink) {
        navigate(notification.deepLink, { state: { back: true } });
      }
    },
    [updateNotification, navigate],
  );

  const handleMarkRead = useCallback(
    (notification: NotificationItem) => {
      updateNotification({ id: notification.id, status: 'read' });
    },
    [updateNotification],
  );

  const handleMarkUnread = useCallback(
    (notification: NotificationItem) => {
      updateNotification({ id: notification.id, status: 'unread' });
    },
    [updateNotification],
  );

  return (
    <NotificationsPage
      notifications={data?.notifications ?? []}
      onNotificationClick={handleNotificationClick}
      onMarkRead={handleMarkRead}
      onMarkUnread={handleMarkUnread}
      onBack={goBack}
      isLoading={isLoading}
    />
  );
};

export default Notifications;
